import React from 'react';

const protectedEventIllustration = (props) => (
    <svg viewBox="0 0 313 173" {...props}>
        <defs>
            <path
                id="path-1"
                d="M2,0 L311,0 C312.104569,-2.02906125e-16 313,0.8954305 313,2 L313,160 L0,160 L0,2 C-1.3527075e-16,0.8954305 0.8954305,2.02906125e-16 2,0 Z"
            />
        </defs>
        <g
            transform="translate(0 -5)"
            id="illustration"
            fill="none"
            fillRule="evenodd"
        >
            <g id="Group-2" transform="translate(0 .466)">
                <mask id="mask-2" fill="#fff">
                    <use xlinkHref="#path-1" />
                </mask>
                <path
                    d="M313,160 C240,-17.2 47.2,25.4 -0.4,160 L313,160 Z"
                    id="Path"
                    fill="#DBDAE3"
                    mask="url(#mask-2)"
                />
                <path
                    d="M73.025,141.564138 C77.575,132.129655 78.987069,121.594483 81.5758621,113.33931 C84.0862069,105.084138 98.912931,81.4193103 101.737069,62.3144828 C104.561207,43.2096552 102.050862,34.4041379 103.462931,33.2248276 C104.875,32.0455172 116.25,33.5393103 116.563793,52.88 C116.877586,72.2206897 116.563793,93.6055172 116.563793,93.6055172 C116.563793,93.6055172 189.912931,37.7062069 195.090517,34.64 C200.189655,31.4951724 203.013793,30.9448276 205.053448,32.9103448 C207.014655,34.8758621 207.877586,37.7848276 201.052586,43.4455172 C194.227586,49.1062069 154.140517,81.6551724 155.238793,83.9351724 C156.337069,86.2151724 159.788793,85.3503448 162.377586,83.3848276 C164.966379,81.4193103 216.428448,42.8951724 221.841379,41.1655172 C227.25431,39.4358621 232.667241,42.5806897 227.568103,49.1062069 C222.468966,55.6317241 168.418103,99.5806897 168.653448,101.86069 C168.967241,104.14069 169.830172,104.376552 172.65431,103.590345 C175.478448,102.725517 219.017241,67.6606897 222.468966,67.6606897 C225.92069,67.6606897 230.156897,71.3558621 222.155172,78.7462069 C214.231897,86.1365517 175.792241,122.302069 176.106034,124.346207 C176.419828,126.390345 179.793103,125.211034 179.793103,125.211034 C179.793103,125.211034 218.15431,106.971034 222.155172,110.115862 C226.156034,113.26069 223.331897,115.54069 220.743103,117.506207 C218.232759,119.550345 115.073276,182.211034 100.952586,193.925517 C90.2051724,202.809655 60.5517241,223.801379 48.2353448,232.685517 L1.23994808,199.534338 C46.063316,167.124779 69.9916667,147.801379 73.025,141.564138 Z"
                    id="Path"
                    fill="#F05537"
                    mask="url(#mask-2)"
                />
                <g transform="translate(81 5)" id="02-tickets-232x320">
                    <polygon
                        id="Rectangle"
                        fill="#1E0A3C"
                        transform="rotate(-56.461 13.19 13.409)"
                        points="13.193031 10.2294078 13.193031 10.2294078 13.1865996 16.5879129 13.1865996 16.5879129"
                    />
                    <polygon
                        id="Rectangle"
                        fill="#1E0A3C"
                        transform="rotate(-81.929 11.323 18.759)"
                        points="11.3240206 16.013129 11.3240206 16.013129 11.3223429 21.5047742 11.3223429 21.5047742"
                    />
                    <polygon
                        id="Rectangle"
                        fill="#1E0A3C"
                        transform="rotate(-30.809 17.358 9.684)"
                        points="17.3608309 6.93390612 17.3608309 6.93390612 17.3555215 12.4343479 17.3555215 12.4343479"
                    />
                    <path
                        d="M29.4448276,143.089655 C29.287931,143.089655 29.1310345,143.011034 28.9741379,142.853793 C28.7387931,142.617931 28.8172414,142.224828 29.0525862,142.067586 L29.0525862,142.067586 C33.837931,137.90069 37.7603448,132.790345 40.5060345,127.051034 C43.0163793,121.626207 44.2715517,115.729655 44.1146552,109.833103 C43.8793103,102.442759 41.4474138,94.8951724 36.8189655,87.3475862 C36.662069,87.0331034 36.7405172,86.7186207 37.0543103,86.5613793 C37.2896552,86.4827586 37.525,86.4827586 37.6818966,86.5613793 C44.0362069,91.8289655 49.9982759,97.6468966 55.4112069,103.857931 C60.275,109.597241 63.8836207,114.943448 66.0801724,119.817931 C68.8258621,125.950345 69.375,131.296552 67.6491379,135.777931 C67.4922414,136.092414 67.1784483,136.171034 66.8646552,136.013793 C66.6293103,135.856552 66.5508621,135.62069 66.5508621,135.384828 C68.1982759,131.217931 67.6491379,126.186207 65.0603448,120.289655 C62.9422414,115.493793 59.412069,110.226207 54.6267241,104.644138 C49.9198276,99.2193103 44.8991379,94.1875862 39.4862069,89.5489655 C43.1732759,96.3103448 45.1344828,103.150345 45.3698276,109.833103 C45.5267241,115.965517 44.2715517,122.01931 41.6827586,127.601379 C37.2112069,137.350345 30.2293103,142.775172 29.9155172,143.011034 C29.6801724,143.011034 29.6017241,143.089655 29.4448276,143.089655 Z"
                        id="Path"
                        fill="#1E0A3C"
                    />
                    <path
                        d="M126.877586,156.21931 L69.4534483,171.393103 C64.1189655,172.808276 58.6275862,169.584828 57.2155172,164.238621 L21.4431034,27.8317241 C20.0310345,22.4855172 23.2474138,16.982069 28.5818966,15.5668966 L86.0060345,0.393103448 C91.3405172,-1.02206897 96.8318966,2.20137931 98.2439655,7.54758621 L134.094828,143.875862 C135.428448,149.30069 132.212069,154.804138 126.877586,156.21931"
                        id="Path"
                        fill="#1E0A3C"
                    />
                    <path
                        d="M96.1258621,155.590345 C95.3413793,155.826207 94.9491379,156.533793 95.1844828,157.32 C95.4198276,158.106207 96.1258621,158.49931 96.9103448,158.263448 C97.6163793,158.027586 98.087069,157.32 97.9301724,156.533793 C97.6948276,155.826207 96.9103448,155.354483 96.1258621,155.590345 C96.2043103,155.590345 96.1258621,155.590345 96.1258621,155.590345 M96.9887931,158.735172 C95.9689655,159.049655 94.9491379,158.42069 94.7137931,157.398621 C94.4,156.376552 95.0275862,155.354483 96.0474138,155.118621 C97.0672414,154.804138 98.087069,155.433103 98.3224138,156.455172 C98.5577586,157.477241 98.0086207,158.49931 96.9887931,158.735172"
                        id="Shape"
                        fill="#CFCED6"
                        fillRule="nonzero"
                    />
                    <path
                        d="M58.5491379,158.656552 L25.4439655,32.6275862 C25.3655172,32.1558621 25.6008621,31.7627586 26.0715517,31.6055172 L96.1258621,13.1296552 C96.5965517,13.0510345 96.9887931,13.2868966 97.1456897,13.7586207 L130.172414,139.708966 C130.250862,140.18069 130.015517,140.573793 129.544828,140.731034 L59.5689655,159.206897 C59.0982759,159.364138 58.6275862,159.049655 58.5491379,158.656552"
                        id="Path"
                        fill="#324B8C"
                    />
                    <path
                        d="M107.893103,73.6675862 L95.3413793,25.8662069 L33.2103448,42.3765517 L45.762069,90.177931 C45.762069,90.177931 47.6448276,97.3324138 47.6448276,97.3324138 L63.8836207,158.263448 L126.014655,141.753103 L109.775862,80.7434483 C109.775862,80.7434483 107.893103,73.6675862 107.893103,73.6675862 Z"
                        id="Path"
                        fill="#FFF"
                    />
                    <polygon
                        id="Path"
                        fill="#DBDAE3"
                        points="101.831958 82.8330201 89.3896451 37 43 49.7362174 55.4423126 95.5692375"
                    />
                    <ellipse
                        id="Oval"
                        fill="#FFF"
                        cx="92.909"
                        cy="23.114"
                        rx="1"
                        ry="1"
                    />
                    <ellipse
                        id="Oval"
                        fill="#FFF"
                        cx="92.36"
                        cy="20.992"
                        rx="1"
                        ry="1"
                    />
                    <ellipse
                        id="Oval"
                        fill="#FFF"
                        cx="91.733"
                        cy="18.869"
                        rx="1"
                        ry="1"
                    />
                    <path
                        d="M0.575862069,108.33931 C3.0862069,100.084138 17.912931,76.4193103 20.737069,57.3144828 C23.5612069,38.2096552 21.0508621,29.4041379 22.462931,28.2248276 C23.875,27.0455172 37.8387931,29.0110345 38.1525862,48.3517241 C38.4663793,67.6924138 37.1327586,88.2124138 37.1327586,88.2124138"
                        id="Path"
                        fill="#F05537"
                    />
                    <path
                        d="M96.5181034,106.295172 L63.4913793,115.493793 C61.9224138,115.886897 60.3534483,115.022069 59.8827586,113.449655 L59.0198276,110.383448 L94.8706897,100.398621 C96.4396552,99.9268966 98.087069,100.870345 98.5577586,102.521379 L98.5577586,102.6 C99.0284483,104.251034 98.087069,105.823448 96.5181034,106.295172 Z"
                        id="Path"
                        fill="#DBDAE3"
                    />
                    <path
                        d="M82.8681034,100.791724 L58.3137931,107.631724 L57.6862069,105.194483 C57.3724138,104.172414 58,103.071724 59.0198276,102.757241 L81.6913793,96.3889655 C82.8681034,96.0744828 84.0448276,96.7034483 84.3586207,97.8827586 L84.3586207,97.9613793 C84.6724138,99.297931 83.9663793,100.477241 82.8681034,100.791724 Z"
                        id="Path"
                        fill="#DBDAE3"
                    />
                    <path
                        d="M84.2017241,128.308966 L67.1,132.947586 C66.1586207,133.183448 65.2172414,132.633103 64.9818966,131.768276 L64.5112069,129.96 L83.2603448,124.849655 C84.2017241,124.613793 85.1431034,125.164138 85.4568966,126.107586 L85.4568966,126.186207 C85.6922414,127.051034 85.1431034,128.073103 84.2017241,128.308966 Z"
                        id="Path"
                        fill="#DBDAE3"
                    />
                    <path
                        d="M75.9646552,124.29931 L63.8836207,127.601379 L63.4913793,126.186207 C63.3344828,125.557241 63.7267241,124.928276 64.2758621,124.771034 L75.2586207,121.783448 C75.8862069,121.626207 76.5922414,122.01931 76.8275862,122.726897 L76.8275862,122.805517 C77.062931,123.434483 76.6706897,124.142069 75.9646552,124.29931 Z"
                        id="Path"
                        fill="#DBDAE3"
                    />
                    <path
                        d="M88.2025862,142.853793 L71.1008621,147.492414 C70.1594828,147.728276 69.2181034,147.177931 68.9827586,146.313103 L68.512069,144.504828 L87.2612069,139.394483 C88.2025862,139.158621 89.1439655,139.708966 89.4577586,140.652414 L89.4577586,140.731034 C89.6146552,141.674483 89.0655172,142.617931 88.2025862,142.853793 Z"
                        id="Path"
                        fill="#DBDAE3"
                    />
                    <path
                        d="M79.9655172,138.844138 L67.8844828,142.146207 L67.4922414,140.731034 C67.3353448,140.102069 67.7275862,139.473103 68.2767241,139.315862 L79.2594828,136.328276 C79.887069,136.171034 80.5931034,136.564138 80.8284483,137.271724 L80.8284483,137.350345 C80.9853448,137.97931 80.5931034,138.686897 79.9655172,138.844138 Z"
                        id="Path"
                        fill="#DBDAE3"
                    />
                    <path
                        d="M115.581034,135.384828 L98.1655172,140.18069 C97.2241379,140.416552 96.2827586,139.866207 96.0474138,139.001379 L95.5767241,137.193103 L114.639655,132.004138 C115.581034,131.768276 116.522414,132.318621 116.836207,133.262069 L116.836207,133.34069 C117.071552,134.126897 116.522414,135.070345 115.581034,135.384828 Z"
                        id="Path"
                        fill="#DBDAE3"
                    />
                    <path
                        d="M107.343966,131.375172 L94.9491379,134.755862 L94.5568966,133.34069 C94.4,132.711724 94.7922414,132.082759 95.3413793,131.925517 L106.716379,128.85931 C107.343966,128.702069 108.05,129.095172 108.285345,129.802759 L108.285345,129.881379 C108.442241,130.510345 107.971552,131.217931 107.343966,131.375172 Z"
                        id="Path"
                        fill="#DBDAE3"
                    />
                </g>
            </g>
            <path
                d="M150,69 L157,69 L157,66.5 C157,64.5670034 155.432997,63 153.5,63 C151.567003,63 150,64.5670034 150,66.5 L150,69 Z M161,69 C163.209139,69 165,70.790861 165,73 L165,83 C165,84.1045695 164.104569,85 163,85 L144,85 C142.895431,85 142,84.1045695 142,83 L142,73 C142,70.790861 143.790861,69 146,69 L146,66.5 C146,62.3578644 149.357864,59 153.5,59 C157.642136,59 161,62.3578644 161,66.5 L161,69 Z"
                id="Combined-Shape"
                fill="#FFF"
                transform="rotate(-15 153.5 72)"
            />
            <g id="Group-3" transform="rotate(-180 115.5 84.5)" fill="#1E0A3C">
                <rect
                    id="Rectangle"
                    transform="rotate(-56.461 6.68 8.237)"
                    x="6.379"
                    y="4.187"
                    width="1"
                    height="8.1"
                />
                <rect
                    id="Rectangle"
                    transform="rotate(-81.929 4.3 15.043)"
                    x="4"
                    y="11.543"
                    width="1"
                    height="7"
                />
                <rect
                    id="Rectangle"
                    transform="rotate(-30.809 11.993 3.5)"
                    x="11.693"
                    width="1"
                    height="7"
                />
            </g>
        </g>
    </svg>
);

export default protectedEventIllustration;
